import { baseUrl } from '../../network'

// export const getCompanyPhoneNumbersUrl = (companyId: number) => baseUrl + `api/settings/phone-numbers/${companyId}`
// export const getCompanyEmailsUrl = (companyId: number) => baseUrl + `api/settings/emails/${companyId}`

export const getCompanySettingsUrl = (companyId: number) => baseUrl + `api/company/${companyId}`
// export const getCompanyContactsUrl = (companyId: number, request: string) => baseUrl + `api/company/${companyId}`
